import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';

/**
 * TREASURY VAULT (Сокровищница) — the keep's TREASURE HOARD, deep in the undercroft. A vault that should
 * RADIATE warm gold, never read as a dull store-room: the HERO is a glowing RELIC PEDESTAL dead-centre
 * (the brightest pool in the room), flanked by twin stone DRAGON guardians; open chests spill coins,
 * jewelled plinths and great gold scales line the floor, and gold-lit wall torches make the whole hoard
 * gleam. A velvet viewing bench faces the relic — the spot ducks sit to admire the guild's spoils.
 *
 * Geometry: zone (2240,2300) 560×340 → centre (2520,2470). Doors on the N wall (x2520 → bailey), the W
 * wall (y2470 → gatehouse) and the E wall (y2470 → catacombs) are kept clear; the hoard hugs the interior.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── The HERO: a glowing relic on its pedestal, dead-centre — the brightest beat of the vault. ──
  place(ctx, kit.relicPedestal(art), 2520, 2440);

  // ── Twin stone DRAGON guardians flanking the relic (ceremonial sentinels of the hoard). ──
  place(ctx, kit.dragonStatue(art), 2440, 2380);
  place(ctx, kit.dragonStatue(art), 2600, 2380);

  // ── Spilling treasure: open coin-chests + jewelled display plinths + the great gold scales. ──
  place(ctx, kit.treasurePile(art), 2330, 2400);
  place(ctx, kit.treasurePile(art), 2700, 2400);
  place(ctx, kit.gemPlinth(art), 2400, 2540);
  place(ctx, kit.gemPlinth(art), 2640, 2540);
  place(ctx, kit.goldScales(art), 2330, 2540);

  // ── The velvet viewing bench facing the relic (the 'treasury-bench' sit anchor). ──
  place(ctx, kit.pew(art, 70), 2520, 2540);

  // ── POOL LIGHT: gold-lit wall torches making the whole hoard gleam warm honey-gold. ──
  place(ctx, kit.wallTorch(art), 2300, 2470);
  place(ctx, kit.wallTorch(art), 2740, 2470);
};

export default decorate;
